import dayjs, { ConfigType, Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export const BUSINESS_TIME_ZONE = 'Europe/Stockholm';

export const inBusinessTimeZone = (value?: ConfigType): Dayjs =>
  dayjs(value).tz(BUSINESS_TIME_ZONE);

export const inTimeZone = (value: ConfigType, timeZone?: string): Dayjs =>
  timeZone ? dayjs(value).tz(timeZone) : dayjs(value);
